const baseClasses =
  "inline-flex items-center justify-center rounded-full font-semibold no-underline transition duration-200 ease-out disabled:pointer-events-none disabled:opacity-50";

const variantClasses = {
  primary:
    "border border-[#fff8ef]/45 bg-[#5a3824] shadow-[0_10px_22px_rgba(58,43,24,0.14)] hover:border-[#fff8ef]/80 hover:bg-[#5a3824] hover:shadow-[0_0_0_4px_rgba(90,56,36,0.18),0_16px_34px_rgba(58,43,24,0.22)] theme-dark:border-white theme-dark:bg-white theme-dark:hover:border-[#ef4444] theme-dark:hover:bg-[#f5f7f2] theme-dark:hover:shadow-[0_0_0_4px_rgba(183,255,74,0.18),0_16px_34px_rgba(0,0,0,0.36)]",

secondary:
  "border border-[#5a3824]/28 bg-[#fff8ef]/90 shadow-[0_10px_24px_rgba(58,43,24,0.10)] hover:border-[#5a3824]/45 hover:bg-[#fff8ef] theme-dark:border-white/20 theme-dark:bg-transparent theme-dark:shadow-none theme-dark:hover:border-[#ef4444]/45 theme-dark:hover:bg-[#ef4444]/10",

  glass:
    "border border-white/20 bg-white/10 backdrop-blur hover:border-white/35 hover:bg-white/15",

  ghost:
    "border border-[#5a3824]/20 bg-transparent shadow-none hover:border-[#5a3824]/40 hover:bg-[#8a5a35]/10 theme-dark:border-white/15 theme-dark:hover:border-[#ef4444]/45 theme-dark:hover:bg-[#ef4444]/10",

  icon:
    "h-12 w-12 border border-[#5a3824]/25 bg-transparent p-0 shadow-none hover:bg-[#8a5a35]/10 theme-dark:border-white/20 theme-dark:hover:border-[#ef4444]/45 theme-dark:hover:bg-[#ef4444]/10",

  danger:
    "border border-red-200 bg-red-50 hover:bg-red-100 theme-dark:border-red-500/25 theme-dark:bg-red-500/10 theme-dark:hover:bg-red-500/15",
};

const textClasses = {
  primary:
    "!text-[#fff8ef] theme-dark:!text-zinc-950",

  secondary:
    "!text-[#241a16] theme-dark:!text-white",

  glass:
    "!text-white",

  ghost:
    "!text-[#241a16] theme-dark:!text-white",

  icon:
    "!text-[#241a16] theme-dark:!text-white",

  danger:
    "!text-red-700 theme-dark:!text-red-200",
};

const sizeClasses = {
  sm: "px-5 py-3 text-sm",
  md: "px-6 py-4 text-sm",
  lg: "px-6 py-4 text-sm",
  icon: "h-12 w-12 p-0",
};

export default function ParanoidiButton({
  href,
  type = "button",
  variant = "primary",
  size = "md",
  className = "",
  children,
  ariaLabel,
  onClick,
  target,
  rel,
  disabled,
}) {
  const finalVariant = variantClasses[variant] ? variant : "primary";
  const finalSize = finalVariant === "icon" ? "icon" : size;

  const classes = [
    baseClasses,
    variantClasses[finalVariant],
    sizeClasses[finalSize] ?? sizeClasses.md,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const content = (
    <span className={["inline-flex items-center justify-center gap-2", textClasses[finalVariant]].join(" ")}>
      {children}
    </span>
  );

  if (href) {
    return (
      <a
        href={href}
        className={classes}
        aria-label={ariaLabel}
        onClick={onClick}
        target={target}
        rel={rel}
      >
        {content}
      </a>
    );
  }

  return (
    <button
      type={type}
      className={classes}
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
    >
      {content}
    </button>
  );
}


